const siteId = process.env.REACT_APP_BUILD_SITE;

const theme = {
  CMBR: {
    primary: '#002B52',
    primaryHover: '#00101F',
    secondary: '#00101F',
    secondaryHover: '#FFEEE5',
    tertiary: '#BED2E3',
    tertiaryHover: '#e5e5e5',
    stepperPrimary: '',
    stepperPrimaryProf: '',
    stepperSecondary: '',
    stepperSecondaryProf: ''
  },
  UBPE: {
    primary: '#0D624E',
    primaryHover: '#0A4C3D',
    secondary: '#0A4C3D',
    secondaryHover: '#FFEEE5',
    tertiaryHover: '#e5e5e5',
    tertiary: '#DDE6E4',
    stepperPrimary: '',
    stepperPrimaryProf: '',
    stepperSecondary: '',
    stepperSecondaryProf: ''
  },
  VAMX: {
    primary: '#037CC2',
    primaryHover: '',
    secondaryHover: '#FFEEE5',
    secondary: '#037CC2',
    tertiaryHover: '#e5e5e5',
    tertiary: '#CBD6DC',
    stepperPrimary: '#53768A',
    stepperPrimaryProf: '#53768A',
    stepperSecondary: '#CBD6DC',
    stepperSecondaryProf: '#CBD6DC'
  },
  COMMON: {
    primary: '#FF5500',
    primaryHover: '#CA4300',
    secondaryHover: '#FFEEE5',
    secondary: '#E64D00',
    tertiaryHover: '#e5e5e5',
    tertiary: '#FFE8DC',
    stepperPrimary: '#FF5500',
    stepperPrimaryProf: '#FF5500',
    stepperSecondary: '#DCD9E6',
    stepperSecondaryProf: '#DCD9E6'
  }
};

export const getColor = color => {
  if (theme[siteId] && theme[siteId][color]) {
    return theme[siteId][color];
  }
  if (theme.COMMON[color]) {
    return theme.COMMON[color];
  }
  return '#000000';
};
